var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailReports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4286 4.64285H3.57143C3.28727 4.64285 3.01475 4.75574 2.81381 4.95667C2.61288 5.1576 2.5 5.43012 2.5 5.71428V14.2857C2.5 14.5699 2.61288 14.8424 2.81381 15.0433C3.01475 15.2443 3.28727 15.3571 3.57143 15.3571H16.4286C16.7127 15.3571 16.9853 15.2443 17.1862 15.0433C17.3871 14.8424 17.5 14.5699 17.5 14.2857V5.71428C17.5 5.43012 17.3871 5.1576 17.1862 4.95667C16.9853 4.75574 16.7127 4.64285 16.4286 4.64285ZM15.25 5.71428L10 9.34642L4.75 5.71428H15.25ZM3.57143 14.2857V6.20178L9.69464 10.4393C9.78432 10.5015 9.89086 10.5348 10 10.5348C10.1091 10.5348 10.2157 10.5015 10.3054 10.4393L16.4286 6.20178V14.2857H3.57143Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailReports);
export default __webpack_public_path__ + "static/media/email_reports.4210c84429d79d22c8908795a10e2241.svg";
export { ForwardRef as ReactComponent };